let debounce = require('../../modules/debounce');
require('./tabs.less');

let heightLimit = require('../height-limit/height-limit');

import Trackers from '../tracker/tracker';

jQuery(function() {
    const trackers = new Trackers();

    $('.js-tabs').each(function() {
        var $this = $(this);

        var horizAnimation = $this.hasClass('js-tabs-horiz-anim');

        var $tabs = $this.find('.tabs__tab');
        var $contentBlocks = $this.find('.tabs__content');
        var $contentBlocksParent = $this.find('.tabs__content-holder');

        var $curContentBlock = $contentBlocks.filter('.tabs__content--current');

        if (horizAnimation) {
            $contentBlocks
                .not($curContentBlock)
                .css('left', '100%')
                .hide();
            $contentBlocks.addClass('tabs__content--anim');
            $curContentBlock.css('left', 0).show();
        }

        $tabs.click(function(e) {
            e.preventDefault();

            if ($this.hasClass('js-tabs-animated')) return;

            var $curTab = $(this);
            var tabName = $curTab.data('tab');

            if ($curTab.hasClass('tabs__tab--current')) return;

            var $curContentBlock = $contentBlocks.filter('.tabs__content--current');
            var $newContentBlock = $contentBlocks.filter('[data-tab=' + tabName + ']');

            if (horizAnimation) {
                $this.addClass('js-tabs-animated');
                $contentBlocksParent.css('min-height', $curContentBlock.height()).css('overflow', 'hidden');
                var direction = $curContentBlock.index() > $newContentBlock.index() ? 'right' : 'left';

                $curContentBlock.css('left', direction == 'right' ? '100%' : '-100%');
                $newContentBlock.css('left', direction == 'right' ? '-100%' : '100%');

                var newBlockHeight = $newContentBlock.height();

                setTimeout(function() {
                    $contentBlocksParent.addClass('tabs__content-holder--anim').css('min-height', newBlockHeight);
                }, 30);
            }

            $tabs.removeClass('tabs__tab--current tabs__tab--prev');
            $curTab.addClass('tabs__tab--current');

            //класс "предыдущий" нужен в целях дизайна
            $curTab.prev().addClass('tabs__tab--prev');

            $contentBlocks.removeClass('tabs__content--current');

            if (horizAnimation) {
                $newContentBlock.show().css('left', 0);

                $newContentBlock.one(
                    'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',
                    function() {
                        $this.removeClass('js-tabs-animated');
                    }
                );

                setTimeout(function() {
                    $curContentBlock.hide();
                    $newContentBlock.addClass('tabs__content--current');
                    heightLimit.checkHeightLimitBlock($newContentBlock.find('.js-height-limit'));
                    $contentBlocksParent.removeAttr('style');
                    $contentBlocksParent.removeClass('tabs__content-holder--anim');
                }, 550);
            } else {
                $newContentBlock.addClass('tabs__content--current');
            }

            trackers.onTabClick({ gtm: $newContentBlock.data('tab') });
        });
    });

    //если при ресайзе внезапно оказывается, что текущий таб скрыт,
    //то покажем первый попавшийся другой.
    //например, "комплексная покупка" отсутствует на мобилках
    debounce.setResizeDebounce(function() {
        $('.js-tabs').each(function() {
            var $this = $(this);
            var $tabs = $this.find('.tabs__tab');
            var $contentBlocks = $this.find('.tabs__content');

            var $curContentBlock = $contentBlocks.filter('.tabs__content--current');

            if (!$curContentBlock.is(':visible')) {
                var curTabName = $curContentBlock.data('tab');

                if (window.location.hash !== '') {
                    var hashCode = window.location.hash.replace(new RegExp('#', 'g'), '');
                    $('[data-tab=' + hashCode + ']').click();
                } else {
                    $tabs
                        .not('[data-tab=' + curTabName + ']')
                        .first()
                        .click();
                }
            }
        });
    });

    /* для данных страниц вкладки не переключаем */
    const notChangePage = ['/search/'];
    /* получаем якорь и в зависимости от него показываем нужную вкладку */
    if (window.location.hash !== '') {
        let curPath = window.location.pathname;
        if (notChangePage.indexOf(curPath) == -1) {
            var tab = false;
            var hashCode = window.location.hash.replace(new RegExp('#', 'g'), '');
            /* проверяем реально ли существует такая вкладка */
            if ($('.tabs__tab[data-tab="' + hashCode + '"]').length) {
                tab = hashCode;
            }
            if (tab) {
                $.each($('.tabs__content'), function(e, selector) {
                    $(selector).removeClass('tabs__content--current');
                    $(selector)
                        .hide()
                        .css('left', '100%');
                    if ($(selector).data('tab') === tab) {
                        $(selector).addClass('tabs__content--current');
                        $(selector)
                            .show()
                            .css('left', 0);
                    }
                });
                $.each($('.tabs__tab'), function(e, selector) {
                    $(selector).removeClass('tabs__tab--current');
                    if ($(selector).data('tab') === tab) {
                        $(selector).addClass('tabs__tab--current');
                    }
                });
            }
        }
    }

    $(window).resize();
});



// WEBPACK FOOTER //
// ./blocks/tabs/tabs.js